module.exports = __webpack_public_path__ + "img/water side -113.9235e893.jpeg";